import React from 'react';
import { FileText } from 'lucide-react';

const ProposalsPanel = ({ proposals, getStatusColor, onViewDetails }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900">My Proposals</h2>
      </div>
      <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
        {proposals.map((proposal) => (
          <div key={proposal.id} className="p-6">
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-lg font-medium text-gray-900">
                {proposal.title}
              </h3>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(proposal.status)}`}>
                {proposal.status}
              </span>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-3">
              <div>
                <p className="font-medium">Proposed Amount</p>
                <p className="text-green-600 font-semibold">{proposal.proposedAmount}</p>
              </div>
              <div>
                <p className="font-medium">Duration</p>
                <p>{proposal.estimatedDuration}</p>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-600">
                Submitted: {proposal.submittedDate}
              </p>
              <button
                onClick={() => onViewDetails(proposal)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                View Details
              </button>
            </div>
          </div>
        ))}

        {proposals.length === 0 && (
          <div className="p-6 text-center text-gray-500">
            <FileText className="h-12 w-12 mx-auto mb-3 text-gray-300" />
            <p>No proposals submitted yet</p>
            <p className="text-sm">Start by submitting proposals for available requests</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProposalsPanel;
